import { Tooltip, Toast, Popover } from 'bootstrap';
import './modules/global';
import './modules/modals';
import './modules/accordion';
import './modules/sliders';
import './modules/header';
import './modules/tables';